export const selector = (str) => document.querySelector(str);
export const selectorAll = (str) => document.querySelectorAll(str);

// window.onerror = function (msg, url, lineNo, columnNo, error) {
//   document.body.style.display = "grid";
//   document.body.style.placeItems = "center";
//   document.body.style.width = "100vw";
//   document.body.style.height = "100vh";
//   document.body.innerHTML = `<h1>${msg}</h1>`;
// };
